import React, { useEffect, useState } from 'react';
import { ReactComponent as PropacityLogo } from '../../assets/propacityplush.svg';
import MobileInput from '../../components/InputGroup/MobileInput';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import InputText from '../../components/InputGroup/InputText';
import InputSelect from '../../components/InputGroup/InputSelect';
import { ReactComponent as WhiteRightNavIcon } from '../../assets/icons/whiteRightNav.svg';
import AsyncSelect from 'react-select/async';
import { getCities } from '../../services/private/csv.service';
import { toast } from 'react-toastify';
import { brokerSignup } from '../../services/public/public.service';
import { fetchToken } from '../../firebase';
import { Oval } from 'react-loader-spinner';
import { getCompanyName } from '../../services/private/plus.leads.service';

import { getBrokerCompanies } from '../../services/private/site-visit.service';
import SelectCompanyModal from './Modal/SelectCompanyModal';
import { getDeviceInfo } from '../../helpers/helpers';

const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const customStyles = {
    option: (styles, state) => ({
        ...styles,
        zIndex: 99,
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9999 }),
    menu: (base, state) => ({
        ...base,
        zIndex: 99,
        // You can also use state.isFocused to conditionally style based on the focus state
    }),

};

const SignupForm = ({ setComponentName, userMobile, isOwner, requestId, setEmpEmail, setEmpName }) => {
    const history = useHistory();
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState(userMobile);
    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [city, setCity] = useState('');
    const [error, setError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isTokenFound, setTokenFound] = useState(false);
    const [companyCode, setCompanyCode] = useState('');
    const [employeeCompany, setEmployeeCompany] = useState();
    const [company, setCompany] = useState('');
    const [showSelectCompany, setShowSelectCompany] = useState(false);
    const [deviceInfo, setDeviceInfo] = useState({});

    useEffect(() => {
        if (userMobile) {
            setMobile(userMobile);
        }
    }, [userMobile]);
    useEffect(() => {
        const load = async () => {
            getDeviceInfo().then(res => {
                console.log(res, 'response')
                setDeviceInfo(res)

            })
        }
        load()
    }, [])

    // const handleGetCompanyName = async (name) => {
    //     const res = await getCompanyName(name);
    //     if (res.data.status === 200) {
    //         console.log(res.data.data, 'response');
    //         setEmployeeCompany(res.data.data?.name)
    //     }

    // }

    const getCompany = async (company) => {
        const res = await getBrokerCompanies(company);
        if (res.data.status === 200) {
            const list = res.data.data
                .filter(i => i.company_name)
                .map(i => (
                    {
                        label: <div className='w-full flex justify-between text-sm sm:text-base'> <span>{i.company_name}</span> <span>{i.owner_name} ({i.owner_mobile})</span> </div>,
                        value: i.id
                    }
                ))
            return list;

            // setCompanyList(list)
        }
    }

    const handleSubmit = async () => {
        if (isOwner === 'Owner') {
            if (!name || !mobile || !city || !companyName) {
                setError(true);
                return;
            } else {
                setError(false);
            }
        }
        if (isOwner === 'Employee') {
            if (!name || !mobile || !company?.id) {
                setError(true);
                return;
            } else {
                setError(false);
            }
        }
        if (!EmailRegex.test(email)) {
            setEmailError(true);
            return;
        } else {
            setEmailError(false);
        }

        setLoading(true);
        const payload = {
            role: isOwner === 'Owner' ? 'owner' : 'employee',
            name: name,
            email: email,
            company_name: isOwner === 'Owner' ? companyName : '',
            mobile: mobile,
            operational_cities: city.length ? city.map(c => c.value) : [],
            company_id: isOwner === 'Employee' ? company?.id : '',
            request_id: requestId,
            device_info: deviceInfo
        }
        try {
            const res = await brokerSignup(payload);
            if (res.data.status === 200) {
                localStorage.setItem('authToken', res.data.data?.token)
                localStorage.setItem('name', name);
                localStorage.setItem('email', email);
                localStorage.setItem('mobile', mobile);
                localStorage.setItem('showCard', true);
                // localStorage.setItem('company_code', res.data.data?.company_code)
                // localStorage.setItem('user_code', res.data.data?.user_code)
                if (companyCode) {
                    localStorage.setItem('showEmployeeCard', true);
                } else {
                    localStorage.setItem('showOwnerCard', true);
                    // setComponentName('paymentplan');
                    // window.location.reload();
                }
                fetchToken(setTokenFound);
                toast.success(res.data.message)
                setLoading(false);
                window.location.reload();
            }
        } catch (err) {
            setLoading(false);
            toast.error(err?.response?.data?.message)
        }
    }

    const loadOptions = (city) => {
        return getCities(city)
            .then((res) => {
                if (res.data.status === 200) {

                    const cities = res.data?.data.map((city) => {
                        return {
                            label: city.name,
                            value: city.name
                        }
                    });
                    return cities;
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    return (
        <div className='bg-white rounded-xl md:max-w-[560px] md:basis-[560px] pt-[72px] pb-[72px] px-6 grow-0 shrink-0 w-11/12 md:!mt-0 !mt-10 md:!mb-0 !mb-10 shadow-shadowcard '>
            <div className='w-[300px] !table mx-auto'>
                <button 
                    type='button' 
                    onClick={() => history.goBack()} 
                    className='text-blue-900 font-medium mb-4'
                >
                    Back
                </button>
                <div className='!mx-auto !table !mb-6'><PropacityLogo /></div>
                {/* <div className='text-textblack font-semibold text-xl leading-8'>Fill Personal Information</div> */}

                <div className='!space-y-5 [&>*]:!m-0 !mt-6'>
                    <InputText
                        label='Role'
                        value={isOwner}
                        disable={true}

                    />
                    {/* {isOwner === 'Employee' && <InputText
                    label='Company Code'
                    placeholder='Enter Company Code'
                    value={companyCode}
                    onChange={(e) => setCompanyCode(e.target.value)}
                    required={true}
                    handleBlur={(e) => {
                        handleGetCompanyName(e.target.value)
                    }}
                    error={(error && !companyCode) ? 'Please company code' : ''}
                />}
                {employeeCompany && <p className='text-base !m-0 font-semibold leading-6 capitalize'>Company - {employeeCompany} </p>} */}
                    <InputText
                        label='Name'
                        placeholder='Rahul'
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value)
                            setEmpName(e.target.value)
                        }}
                        required={true}
                        error={(error && !name) ? 'Please enter name' : ''}
                    />

                    {/* {isOwner === 'Employee' && <div className='cursor-pointer !mt-4' onClick={() => { }}>
                        <span className='text-base text-blue-900 font-semibold leading-9'>Couldn’t Find Your Company?</span>
                    </div>} */}
                    <div>
                        <div className='flex justify-between'>
                            <label htmlFor="">Mobile</label>
                            <a className='text-blue-900 text-sm font-medium' onClick={() => setComponentName('login')}>Edit No</a>
                        </div>
                        <MobileInput
                            // label='Mobile'
                            value={mobile}
                            onChange={(e) => setMobile(e.phone)}
                            error={(error && !mobile) ? 'Please enter mobile' : ''}
                            disable={userMobile ? true : false}
                            inputclass='!h-10'
                        />
                    </div>
                    <InputText
                        label='Email'
                        placeholder='olivia@untitledui.com'
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value)
                            setEmpEmail(e.target.value)
                        }}
                        // required={true}
                        error={(email && emailError) ? 'Please enter a valid email.' : ''}
                    />
                    {isOwner === 'Owner' && <InputText
                        label='Company Name'
                        placeholder='Enter company name'
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        required={true}
                        error={(error && !companyName) ? 'Please enter company name' : ''}
                    />}
                    {isOwner === 'Owner' && <div className={`form-group font-medium ${(error && city.length === 0) ? 'invalid' : ''}  position-relative`}>
                        <label htmlFor="">Operational City <sup>*</sup></label>
                        <AsyncSelect
                            cacheOptions
                            loadOptions={loadOptions}
                            defaultOptions
                            placeholder='Search and Select'
                            isMulti={true}
                            value={city}
                            styles={customStyles}
                            onChange={(e) => {
                                setCity(e)
                            }}
                            menuPosition='fixed'
                        />
                        {(error && city.length === 0) && (
                            <>
                                <div className="input-feedback mt-8"> Please select operational city
                                </div>
                            </>)}

                    </div>
                    }
                    {isOwner === 'Employee' &&
                        <div className='form-group font-medium'>
                            <label htmlFor="">Company Name</label>
                            <div className='form-control text-input !h-10 !text-base cursor-pointer' onClick={() => {
                                setShowSelectCompany(true)
                            }}>
                                {company ? company?.company_name : ''}
                                {!company && <span className='text-black700'>Select Company</span>}
                                {(error && !company) && (
                                    <>
                                        <div className="input-feedback mt-8"> Please select company
                                        </div>
                                    </>)}
                            </div>
                            {/* <AsyncSelect
                                cacheOptions
                                loadOptions={getCompany}
                                defaultOptions
                                placeholder='Search and Select Company'
                                styles={customStyles}
                                value={companyId}
                                onChange={(e) => {
                                    setCompanyId(e)
                                }}
                                isClearable={true}
                                menuPosition={'fixed'}

                            /> */}
                        </div>
                    }
                    <div className='!mt-6'>
                        {!loading && <button
                            type='button'
                            onClick={handleSubmit}
                            disabled={loading}
                            className='w-100 shadow-inset-blue gradient-blue text-white text-base font-medium !rounded-lg !py-2 !mt-1 inline-flex items-center gap-x-2.5 justify-center'
                        >
                            {isOwner == 'Employee' ? 'Create Account' : 'Create Profile'} <WhiteRightNavIcon />

                        </button>}
                        {
                            loading && <button
                                disabled={true}
                                className='w-100 shadow-inset-blue gradient-blue text-white text-base font-medium !rounded-lg !py-2 !mt-1 inline-flex items-center gap-x-2.5 justify-center'
                            >
                                <Oval
                                    height={30}
                                    width={30}
                                    color="#FFFFFF"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                    ariaLabel='oval-loading'
                                    secondaryColor="#FFFFFF"
                                    strokeWidth={4}
                                    strokeWidthSecondary={4}
                                />
                            </button>
                        }
                    </div>
                </div>
            </div>
            {showSelectCompany && <SelectCompanyModal
                show={showSelectCompany}
                closeModal={() => setShowSelectCompany(false)}
                setCompany={setCompany}
                setComponentName={setComponentName}
            />}
        </div>
    )
}

export default SignupForm
